<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-content-header-component
      v-bind="$props"
      :class="evaluateClasses(classes)"
    ></dr-content-header-component>
  </dr-wrapper>
  <dr-content-header-component
    v-else-if="isVisible"
    v-bind="$props"
    :class="evaluateClasses(classes)"
    @callDataSourceAction="$emit('callDataSourceAction', $event)"
  ></dr-content-header-component>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import drContentHeaderComponent from './dr-content-header-component'

export default {
  mixins: [mixin, inputMixin],
  components: {
    drContentHeaderComponent
  }
}
</script>